export const buttonElementModel = {
  label: "Submit",
  onClick: () => {},
  type: "button",
  className: "",
  disabled: false,
  style: {},
  removeDefaultStyle: false,
};
